import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
  selector: 'app-additional-services',
  templateUrl: './additional-services.component.html',
  styleUrls: ['./additional-services.component.scss'],
})
export class AdditionalServicesComponent implements OnInit, AfterViewInit {
  additionalServiceDetails: FormGroup;
  addtServiceDataSource = new MatTableDataSource<any>();
  addtServiceData: any;
  isValueChanged: boolean = false;
  editable: boolean = false;
  trueFalseOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];
  globalServiceNames = [
    { label: 'ADR LOAD EXEMPTION', key: 'HN' },
    { label: 'Adult Signature', key: 'SD' },
    { label: 'AUTOMATED DIGITAL IMAGING', key: 'PJ' },
    { label: 'BONDED STORAGE', key: 'WK' },
    { label: 'BONDED TRANSIT', key: 'WL' },
    { label: 'DATA STAGING 03', key: 'PT' },
    { label: 'DATA STAGING 06', key: 'PU' },
    { label: 'DATA STAGING 12', key: 'PV' },
    { label: 'DATA STAGING 24', key: 'PW' },
    { label: 'Additional Shipment Data Merge', key: 'PM' },
    { label: 'DELIVERY NOTIFICATION', key: 'JA' },
    { label: 'DIRECT SIGNATURE', key: 'SF' },
    { label: 'Excepted Quantities', key: 'HH' },
    { label: 'GOGREEN CLIMATE NEUTRAL', key: 'EA' },
    { label: 'LIMITED QUANTITIES ADR', key: 'HL' },
    { label: 'NO SIGNATURE REQUIRED', key: 'SX' },
    { label: 'PROACTING TRACKING', key: 'JD' },
    { label: 'Neutral Description Label', key: 'PP' },
    { label: 'Biological Substance', key: 'HY' },
    { label: 'Dry Ice UN1845', key: 'HC' },
    { label: 'Verified Delivery', key: 'TF' },
    { label: 'Duties and Taxes Prepaid', key: 'DD' },
  ];
  columns: string[] = [
    'number',
    'globalServiceName',
    'spServiceCode',
    'baby',
    'mother',
    'individualShipment',
    'action',
  ];

  constructor(
    private fb: FormBuilder,
    private configService: ConfigService,
    private errorDialogService: ErrorDialogService
  ) {}

  ngOnInit(): void {
    this.additionalServiceDetails = this.fb.group({
      config_id: 'additional_services',

      data: this.fb.array([]),
    });

    this.getAddtnlServiceConfig();
  }
  addNewServiceConfig() {
    const control = this.additionalServiceDetails.get('data') as FormArray;
    control.insert(
      (this.additionalServiceDetails.get('data') as FormArray).controls.length + 1,
      this.addAddtnServiceGrp()
    );
    this.addtServiceDataSource = new MatTableDataSource(control.controls);
  }

  setadditionalServiceCode(i, value) {
    const serviceObj = this.globalServiceNames.find(keys => keys.label === value);
    const control = (this.additionalServiceDetails.get('data') as FormArray).controls[i].get(
      'serviceCode'
    );
    control.setValue(serviceObj.key);
  }

  deleteServiceConfig(_formElement, i) {
    const control = this.additionalServiceDetails.get('data') as FormArray;
    control.removeAt(i);
    this.addtServiceDataSource = new MatTableDataSource(
      (this.additionalServiceDetails.get('data') as FormArray).controls
    );
  }

  private addAddtnServiceGrp(): FormGroup {
    return this.fb.group({
      serviceCode: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(2)])
      ),
      globalServiceName: new FormControl('', Validators.compose([Validators.required])),
      isBaby: new FormControl(false, Validators.compose([Validators.required])),
      isMother: new FormControl(false, Validators.compose([Validators.required])),
      isIndividualShipment: new FormControl(false, Validators.compose([Validators.required])),
    });
  }

  getAddtnlServiceFormControlId(id, control) {
    return (this.additionalServiceDetails.get('data') as FormArray).controls[id].get(control);
  }

  getAddtnlServiceConfig() {
    this.configService.fetchConfig('additional_services').then(res => {
      if (res.data) {
        this.additionalServiceDetails.patchValue(res);
        this.addtServiceData = res;
        const addtnServicesArray = res.data;
        (this.additionalServiceDetails.get('data') as FormArray).clear();
        if (addtnServicesArray.length > 0) {
          addtnServicesArray.forEach(item => {
            const addtnServiceGrp = this.addAddtnServiceGrp();
            addtnServiceGrp.patchValue(item);
            (this.additionalServiceDetails.get('data') as FormArray).push(addtnServiceGrp);
          });
          this.addtServiceDataSource = new MatTableDataSource(
            (this.additionalServiceDetails.get('data') as FormArray).controls
          );
        }
      }
    });
  }

  saveAddtnlServiceConfig() {
    const config = this.additionalServiceDetails.value;
    config.config_id = 'additional_services';
    const newConfig = config.data.map(item => {
      const container = {};
      container['serviceCode'] = item.serviceCode;
      container['globalServiceName'] = item.globalServiceName;
      container['isBaby'] = this.getBooleanVal(item.isBaby);
      container['isMother'] = this.getBooleanVal(item.isMother);
      container['isIndividualShipment'] = this.getBooleanVal(item.isIndividualShipment);
      return container;
    });
    config.data = newConfig;

    this.configService.saveConfig(config).subscribe(async () => {
      this.errorDialogService.openDialog('alert.configurationSuccess', false);
      this.isValueChanged = false;
      this.configService.putConfig(config.config_id, config.data);

      const hasPM = newConfig.filter(f => f.serviceCode == 'PM')[0] || null;
      const imageProperties = await this.configService.fetchConfig('output_imageproperties');
      let imageOptions = imageProperties.data[0].imageOptions;

      imageOptions = imageOptions.map(b => {
        const returnV = b;
        if (b.invoiceType == 'commercial') {
          returnV.isRequested = hasPM ? false : true;
        }
        return returnV;
      });

      const data = imageProperties.data[0];
      data.imageOptions = imageOptions;
      this.configService.putConfig('output_imageproperties', [data]);
    });
  }

  ngAfterViewInit() {
    this.isAnyValueUnChanged();
  }

  isAnyValueUnChanged() {
    setTimeout(() => {
      setTimeout(
        function () {
          this.additionalServiceDetails.valueChanges.subscribe(() => {
            this.isValueChanged = true;
          });
        }.bind(this),
        0
      );
    }, 1000);
  }

  getTransformedData(arr) {
    const newConfig = arr.map(item => {
      const container = {};
      container['serviceCode'] = item.serviceCode;
      container['globalServiceName'] = item.globalServiceName;
      container['isBaby'] = this.getBooleanVal(item.isBaby);
      container['isMother'] = this.getBooleanVal(item.isMother);
      container['isIndividualShipment'] = this.getBooleanVal(item.isIndividualShipment);
      return container;
    });
    return newConfig;
  }

  getBooleanVal(val) {
    return val.toString() === 'true';
  }
}
